import * as React from 'react';

import ActionButtonDropdown from 'components/buttons/action-button-dropdown/ActionButtonDropdown';

import { insertIf } from 'utils/list';
import { __t, applyTranslations } from 'utils/language';

import type { ActionButtonDropdownItem } from 'components/buttons/action-button-dropdown/types/ActionButtonDropdown.type';

applyTranslations(require('./campaign-report-download-button.i18n.json'));

type Props = {
  withPPTDownload: boolean,
  onDownloadExcel: () => void,
  onDownloadPPT: () => void,
  isDisabled?: boolean,
  isDownloading?: boolean
};

const DOWNLOAD_EXCEL = 'download-excel';
const DOWNLOAD_PPT = 'download-ppt';

const getDownloadItems = (withPPTDownload: boolean) => ([
  {
    id: 2,
    identifier: DOWNLOAD_EXCEL,
    value: DOWNLOAD_EXCEL,
    label: __t('campaign_report_download_button.item_download_excel'),
    isDisabled: false,
    isFocused: false,
    isSelected: false
  },
  ...insertIf(withPPTDownload, {
    id: 4,
    identifier: DOWNLOAD_PPT,
    value: DOWNLOAD_PPT,
    label: __t('campaign_report_download_button.item_download_ppt'),
    isDisabled: false,
    isFocused: false,
    isSelected: false
  })
]);

class CampaignReportDownloadButton extends React.PureComponent<Props> {
  handleActionButtonClick = (items: Array<ActionButtonDropdownItem>): void => {
    const { onDownloadExcel, onDownloadPPT } = this.props;

    const selectedItemIdentifier = items.find((item) => item.isSelected)?.identifier || '';

    if (DOWNLOAD_EXCEL === selectedItemIdentifier) {
      onDownloadExcel();
    }

    if (DOWNLOAD_PPT === selectedItemIdentifier) {
      onDownloadPPT();
    }
  };

  render(): React.ReactNode {
    const {
      isDisabled,
      isDownloading,
      withPPTDownload
    } = this.props;

    const items = getDownloadItems(withPPTDownload);

    return (
      <ActionButtonDropdown
        disabled={isDisabled}
        onClick={this.handleActionButtonClick}
        label={__t('campaign_report_download_button.button_label')}
        items={items}
        name="download-custom-report"
        withSpinner={isDownloading}
        customSize={{
          width: 144
        }}
      />
    );
  }
}

export default CampaignReportDownloadButton;
